export default "__VITE_PUBLIC_ASSET__4c7ee629__"